import { ChangeDetectorRef, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';

import { Table } from 'primeng/table';
import { TaskConstants } from 'app/modules/task/shared/task-constants';
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-notifications-log',
	templateUrl: './notifications-log.component.html',
	styleUrls: ['./notifications-log.component.css'],
	encapsulation: ViewEncapsulation.None,
	styles: [``],
	providers: [TranslateService],
})
export class NotificationsLogComponent {
	columns: any[];
	@Input() notficationsLogs: Rest_task.NotificationLog[] = [];
	constructor(public translate: TranslateService) {
		this.setColumns();
	}

	setColumns() {
		this.columns = []
 		this.columns.push({
			field: 'type',
			header: this.translate.instant('logistics.orders.notification'),
			type: 'text',
		});
		this.columns.push({
			field: 'sendingDate',
			header: this.translate.instant('logistics.routes.date'),
			type: 'text',
		});
		this.columns.push({
			field: 'mailReceiver',
			header: 'MAIL',
			type: 'text',
		});
		this.columns.push({
			field: 'smsReceiver',
			header: 'SMS',
			type: 'text',
		});
	 
	}
	ngOnDestroy() {}
}
